import React from 'react';
import { Box, Text } from '@wix/design-system';
import style from './app-box.module.scss';
import { AppIcon } from '../app-icon';
import { useEssentials } from '../../contexts/essentials-context';
import { AppReviewsInfo } from './app-box-elements/app-reviews-Info';
import { CTAButton } from './app-box-elements/cta-button';
import { NarrowAppBox, NarrowSlimAppBox, } from './app-box-layouts/narrow-app-box';
import { RegularAppBox, RegularSlimAppBox, } from './app-box-layouts/regular-app-box';
import { WideAppBox } from './app-box-layouts/wide-app-box';
import { AppInfoBadge } from '../app-info-badge';
import { appBoxDataHooks } from './data-hooks';
import { useSiteContext } from '../../contexts/site-context';
import { shouldShowPremiumRequired } from '../app-info-badge/app-info-badge.util';
import { AppBadges } from '../badges/app-badges';
import { isAppWithBenefits } from '@wix/app-market-services';
export function AppBox({ appData, onClick, options = {}, href, languageCode = 'en', skin = 'default', }) {
    const { slug, icon, name, company, shortDescription, reviews, installation, pricing, appBadges = [], } = appData;
    const { showCTA = false, showCompanyName = false, showRating = true, showPricing = true, showBorder = true, showBadgesVertical = true, } = options;
    const { t } = useEssentials();
    const { isPremiumSite } = useSiteContext();
    const renderTopBadge = () => {
        return (React.createElement(Box, { direction: showBadgesVertical ? 'vertical' : 'horizontal', align: "right", gap: showBadgesVertical ? '3px' : '6px' },
            React.createElement(AppBadges, { isInstalled: Boolean(installation?.isInstalled), appName: name ?? '', appBadges: appBadges, languageCode: languageCode, maxCount: skin === 'slim' ? 1 : 2 })));
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onClick?.();
        }
    };
    const appBoxLayoutProps = {
        appIcon: (React.createElement(AppIcon, { iconUrl: icon ?? '', appName: name ?? '', className: style.icon, size: skin === 'slim' ? 'medium' : 'small' })),
        appName: (React.createElement(Text, { size: "small", weight: "bold", ellipsis: skin === 'slim' }, name)),
        companyName: showCompanyName ? (React.createElement(Text, { secondary: true, size: "tiny", weight: "thin" }, t('solutionBox.solutionDetails.companyName', {
            company: company?.name,
        }))) : null,
        appTeaser: (React.createElement(Text, { size: "small", weight: "thin", secondary: skin === 'slim', maxLines: skin === 'slim' ? 2 : undefined, ellipsis: skin === 'slim' }, shortDescription)),
        ctaButton: showCTA ? (React.createElement(CTAButton, { onClick: () => onClick?.() }, installation?.isInstalled
            ? t('apps.grid.cta.button.installed')
            : t('apps.grid.cta.button'))) : null,
        reviewsInfo: showRating && reviews ? (React.createElement(AppReviewsInfo, { reviews: reviews, skin: skin })) : null,
        bottomBadge: (React.createElement(AppInfoBadge, { isAppInstalled: !!installation?.isInstalled, isAppBuiltIn: !!installation?.isBuiltIn, isAppSetupIncomplete: !!installation?.isSetupIncomplete, isAppWithBenefits: isAppWithBenefits(appBadges), pricing: pricing, options: {
                showPricing,
                showPremiumRequired: shouldShowPremiumRequired(!!installation?.requirements?.premiumSite, isPremiumSite),
            }, skin: skin })),
        topBadge: renderTopBadge(),
    };
    return (React.createElement("div", { "data-hook": appBoxDataHooks.container, className: `${style.appBoxContainer} ${skin === 'slim' ? style.skinSlim : style.skinDefault}` },
        React.createElement("div", { "data-hook": slug, className: `${style.appBox} ${!showBorder ? style.noBorder : ''}`, onClick: (e) => {
                onClick?.();
                e.preventDefault();
            }, tabIndex: 0, onKeyDown: handleKeyDown, style: {
                ...(skin === 'slim' && {
                    padding: '18px 12px 12px 15px',
                }),
            } },
            React.createElement("a", { className: style.link, href: href }, skin === 'slim' ? (React.createElement(React.Fragment, null,
                React.createElement(NarrowSlimAppBox, { ...appBoxLayoutProps, className: style.narrowSlimLayout }),
                React.createElement(RegularSlimAppBox, { ...appBoxLayoutProps, className: style.regularSlimLayout }))) : (React.createElement(React.Fragment, null,
                React.createElement(NarrowAppBox, { ...appBoxLayoutProps, className: style.narrowLayout }),
                React.createElement(RegularAppBox, { ...appBoxLayoutProps, className: style.regularLayout }),
                React.createElement(WideAppBox, { ...appBoxLayoutProps, className: style.wideLayout })))))));
}
//# sourceMappingURL=app-box.js.map